if ( jQuery( '.homepage-banner .banner-background' ).length ) {
  jQuery( '.homepage-banner .banner-background' ).slick( {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: true,
    dots: true,
    rows: 0,
    focusOnSelect: true
  } );
}

jQuery( document ).ready( function() {
  jQuery( '#homepageBannerScrollToBigSlider' ).on( 'click', function() {
    $( 'html, body' ).animate( {
      scrollTop: $( "#bigLinkedSliderContainer" ).offset().top - 150
    }, 200 );
  } );
} );

jQuery( document ).ready( function() {
  jQuery( '#homepageBannerScrollToTestimonials' ).on( 'click', function() {
    $( 'html, body' ).animate( {
      scrollTop: $( "#testimonialSlider" ).offset().top - 150
    }, 200 );
  } );
} );